export { default } from './HiddenText';
